import { KEYS } from 'src/app/shared/utils/constants/storage.constants';
import { UserCategoryType } from 'src/app/shared/utils/SubscriptionUtil';
import { Language, BaseSubscription, UserType } from '../model/newrelic.model';
import { LocalStorageService } from 'src/app/shared/services/storage/local-storage.service';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { getPreferredLanguages } from 'src/app/shared/utils/deviceUtils';
import { DataService } from 'src/app/data.service';

@Injectable({
  providedIn: 'root',
})
export class CommonAttributeFunc {
  constructor(
    private readonly localStorage: LocalStorageService,
    private readonly authService: AuthService,
    private readonly dataService: DataService
  ) {}

  private LANGUAGE_MAP = {
    te: Language.TELUGU,
    en: Language.ENGLISH,
    ta: Language.TAMIL,
  } as const;

  public getLanguageInfo() {
    const watchLang = this.localStorage.getItem(KEYS.WATCH_LANGUAGE) || '';
    const displayLang = this.localStorage.getItem(KEYS.DISPLAY_LANGUAGE) || '';

    const contentLanguage =
      watchLang === 'te' ? Language.TELUGU : Language.TAMIL;
    const displayLanguage = this.LANGUAGE_MAP[displayLang] || Language.TAMIL;

    return {
      contentLanguage: Language.TELUGU + ',' + Language.TAMIL,
      // displayLanguage,
      preferredLanguage: getPreferredLanguages(
        this.dataService.isFromDeeplink
          ? this.localStorage.getItem(KEYS.DL_PREFERRED_LANGUAGES)
          : null
      ),
    };
  }

  public getSubscriptionInfo() {
    const hasAccessToken =
      this.localStorage.getItem(KEYS.EVERGENT_ACCESS_TOKEN)?.length > 0;
    const userEntitlements = this.localStorage.getItem(
      KEYS.SUBSCRIPTION_STATUS
    );
    const baseSubscriptionValue =
      this.localStorage.getItem(KEYS.SUBSCRIPTION_PRODUCT_CODES) ||
      this.localStorage.getItem(KEYS.SUBSCRIPTION_PACKAGE);

    const silentLogin = hasAccessToken;
    const baseSubscription = this.determineBaseSubscription(
      userEntitlements,
      baseSubscriptionValue
    );

    return {
      silentLogin,
      baseSubscription,
    };
  }

  public getDeviceID() {
    return this.localStorage.getItem(KEYS.DEVICE_REF) || '';
  }

  private determineBaseSubscription(
    userEntitlements: string | null,
    baseSubscriptionValue: string | null
  ): string {
    const isSubscribed = userEntitlements === 'true';
    const hasValidPackage = !!baseSubscriptionValue;

    return isSubscribed && hasValidPackage
      ? baseSubscriptionValue
      : BaseSubscription.NO_SUBSCRIPTION;
  }

  public getUserInfo() {
    const userID = this.localStorage.getItem(KEYS.CP_CUSTOMER_ID)
      ? this.localStorage.getItem(KEYS.CP_CUSTOMER_ID)
      : '';
    const profileID = this.localStorage.getItem(KEYS.SELECTED_PROFILE_ID) || '';
    return {
      userID,
      profileID,
    };
  }

  public getUserCategory(): string {
    return this.localStorage.getItem(KEYS.SUBSCRIPTION_PACKAGE) || undefined;
    /* let userCategory: string;
    let subPackage = this.localStorage.getItem(KEYS.SUBSCRIPTION_PACKAGE);
    console.log('<<<subPackage>>>>', subPackage);
    if (subPackage) {
      subPackage = subPackage?.toUpperCase();
      if (subPackage.includes('TAMIL') && subPackage.includes('TELUGU')) {
        userCategory = UserCategoryType.GOLD;
      } else if (subPackage.includes('TELUGU')) {
        userCategory = UserCategoryType.TELUGU;
      } else if (subPackage.includes('TAMIL')) {
        userCategory = UserCategoryType.TAMIL;
      } else {
        userCategory = UserCategoryType.NA;
      }
    } else {
      userCategory = UserCategoryType.NA;
    }
    return userCategory; */
  }

  public getUserType(): string {
    const subscriptionPackage = this.localStorage.getItem(
      KEYS.SUBSCRIPTION_PACKAGE
    );
    if (subscriptionPackage) {
      return UserType.SUBSCRIBED;
    } else if (this.authService.isLoggedIn()) {
      return UserType.REGISTERED;
    }
    return UserType.ANONYMOUS;
  }
}
